<template>
  <div>
  </div>
</template>

<script>
import Axios from 'axios'

import Cart from '@/cart'
import Utils from '@/utils'
import PaymentService from '@/service/Payment'

export default {
  props: ['paymentOptions'],
  data() {
    return {
      Cart: Cart,
      complete: false,
      keys: {
        sig: null
      },
      stripe: null,
      elements: null,
      card: {
        number: null,
        expiry: null,
        cvc: null
      },
      stripeLoaded: true,
      cardNumberInvalid: false,
      cardExpiryInvalid: false,
      cardCvcInvalid: false,
    }
  },
  components: {},
  async created() {
    console.log('PayURedirect:create')

    this.$parent.$parent.$off('submitPayment')
    this.$parent.$parent.$on('submitPayment', () => {
      console.log('Customer clicked to pay the order')
      this.pay();
    });
  },
  methods: {
    dontSubmit(event) {
      event.preventDefault()
    },
    async pay() {
      console.log('PayUInline.vue:pay() Getting redirect URI')
      let paymentConfig = Cart.shopData.payments.methods.filter(m => {
        return m.code == 'CARD_ONLINE';
      })
      console.log('Payment config', paymentConfig)

      const redirectData = (await PaymentService.action('PAYU', 'start', {}))
      console.log('redirectData', redirectData)

      if (redirectData.result.orderId) {
        console.log('Redirect Data', JSON.stringify(redirectData))
        // This will redirect us to payment gate... the rest is asynchronous.
        window.location = redirectData.result.redirectUri
      } else {
        Cart.data.processingState = 'failed'
        Cart.globals.overlayActive = false
        setTimeout(() => {
          Cart.data.processingState = 'init'
        }, 3000)
      }
    }
  }
}
</script>

<style lang='less' scoped>
@import '../../../variables.less';

</style>
